<template>
    <div v-if="menu_tab_view.setBusinessCategoryProductOrders">
        <div class="detail-card" v-if="Object.keys(product.product_orders).length > 0">
          <h6>Product Orders</h6>
          <div class="orders-panel" style="">
            <table class="table table-striped" style="width:100%; text-align: left;">
              <th style="width:25%;" class="tcol">Date</th>
              <th style="width:50%;" class="tcol">From</th>
              <th style="width:10%;" class="tcol">Qty</th>
              <th style="width:15%;" class="tcol">Status</th>
              <tr v-for="order in product.product_orders" :key="order.order_id">
                <td style="width:20%;">
                  <span style="color:#df4d4d; font-size: 10px;"><u><b>{{order.order_time_ago}}</b></u></span><br/>
                    {{order.order_date}}
                </td>
                <td style="width:50%;">
                  {{order.order_user}}
                </td>
                <td style="width:20%;">{{order.order_item_quantity}}</td>
                <td style="width:10%;"><span :style="{color:order.order_payment_status_color}">{{order.order_payment_status}}</span></td>
              </tr>
            </table>
          </div> 
        </div>
        <p v-else class="sp-app-default-color">No orders yet</p>
      </div>
</template>

<style>
 @import url("style.css");
</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        self.product =  value.account.store_sellpoint.store_product;
                    }else{}
                });
           
            },
        },

        components: {},

        created: function(){
            this.setPage();
        }
    }
</script>


// WEBPACK FOOTER //
// ProductOrders.vue?34144474